import { PureComponent } from 'react'
import _ from 'lodash'

import { Toast, Modal } from '@vzmi/shp_shared_compo'
import { validateFlow } from '../../../../../Common/ProposalForm/Shared/validation/validations'
import { numericality, required } from 'redux-form-validators'
import { getProductNameLengthMaxInSettingModal, getProductNameLengthMax } from '../../../../../Common/ProposalForm/Shared/util'
import styles from './SpecSettingModal.css'
import SpecSetting from './SpecSetting'
import { SPEC_ATTRIBUTE_VALIDATE_RULE_TEXT } from '../../../../../../../constants/proposalTypes'
import { noEmoji } from '../../../../../../../lib/Validator'
// import validationList from '../../../../../Common/ProposalForm/Shared/validation/validationList'

const getSpecSettingProductNameValidation = _.memoize((lengthMax) => {
  // 拿掉關於長度的檢查, 這裏的長度檢查必須遵守lengthMax
  // let filteredValidation = []
  // _.forEach(validationList['product.name'], func => {
  //   if (_.isEmpty(func.name)) {
  //     filteredValidation.push(func)
  //   }
  // })
  return validateFlow(
    shouldUnderOrEqual(lengthMax),
    required({ msg: '請輸入賣場名稱' }),
    noEmoji({ msg: '請勿使用表情符號' })
  )
})

const shouldUnderOrEqual = lengthMax => (value = '') => {
  const valueLength = value ? value.length : 0
  const overLengthMaxMsg = `商品名稱 = ${SPEC_ATTRIBUTE_VALIDATE_RULE_TEXT}，需在${lengthMax}字以內`
  return numericality({
    '<=': lengthMax,
    msg: overLengthMaxMsg
  })(valueLength)
}

class SpecSettingModal extends PureComponent {
  transformValues = (values) => {
    const { specItems } = values
    const localSpecItems = _.map(specItems, item => {
      const { oldValue, value, values, displayName } = item
      const nextDisplayName = oldValue !== value ? value : displayName
      return { label: nextDisplayName, displayName: nextDisplayName, value, values }
    })
    return { ...values, specItems: localSpecItems }
  }

  submitForm = (values) => {
    this.props.submitForm(this.transformValues(values))
  }

  handleOk = (e) => {
    const { onOk, handleSubmit } = this.props
    const triggerFormSubmit = handleSubmit(this.submitForm)
    const hasError = triggerFormSubmit()
    if (!hasError) {
      onOk(e)
    } else {
      Toast.warning('項目修改有誤，請重新檢查再儲存')
    }
  }

  render () {
    const props = this.props
    const { productName, defaultFormData, showExpiringAddon, level, lengthUsedByFirstLayer, invalid, proposalType } = props
    const currentProductNameLengthMax = getProductNameLengthMax(showExpiringAddon, proposalType)
    const lengthMaxInModal = getProductNameLengthMaxInSettingModal(currentProductNameLengthMax, level, lengthUsedByFirstLayer)
    const productNameValidation = getSpecSettingProductNameValidation(lengthMaxInModal)
    const disableForm = productNameValidation(productName || defaultFormData.productName) || invalid
    return (
      <Modal
        ref={c => (this.form = c)}
        {...props}
        title='項目設定'
        onOk={this.handleOk}
        okText='儲存'
        cancelText='放棄修改'
        destroyOnClose
        okButtonDisabled={disableForm}
        className={`spec-setting-modal ${styles.SpecSettingModal}`}
      >
        <SpecSetting
          {...props}
          formInstance={this.form && this.form}
          productNameValidation={productNameValidation}
          currentProductNameLengthMax={currentProductNameLengthMax}
          lengthMaxInModal={lengthMaxInModal}
          disableForm={disableForm}
        />
      </Modal>
    )
  }
}

export default SpecSettingModal
